export default __webpack_public_path__ + "static/media/meetups-thumb-01.4e3be405.jpg";